import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translations_DE from "./translations_de";
import translations_EN from "./translations_en";
import translations_FR from "./translations_fr";
const resources = {
    'de-DE': translations_DE,
    'de-CH': translations_DE,
    'de-AT': translations_DE,
    'en-GB': translations_EN,
    'en-US': translations_EN,
    'fr-FR': translations_FR
  };

i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
//   .use(Backend)
//   detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
//   .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    fallbackLng: 'en-GB',
    debug: true,
    lng:'en-GB',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });


export default i18n;